<template>
  <div class="planning">
    <planning-list v-if="getApplicationSetting('ipad_planning_view') === 'list'" />
    <planning-time-registration v-else-if="getApplicationSetting('ipad_planning_view') === 'time_registration'" />
    <planning-default v-else />
  </div>
</template>

<script>
import PlanningList from '@/views/planning/List'
import PlanningDefault from '@/views/planning/Default'
import PlanningTimeRegistration from '@/views/planning/Time-Registration'
export default {
  name: 'planning',
  components: {
    PlanningList,
    PlanningDefault,
    PlanningTimeRegistration
  }
}
</script>

<style scoped>
</style>
